export const viTri = {
  sections: {
    list: { title: 'Vị trí kho' },
    detail: { title: 'Vị trí kho' },
  },
  titles: { add: 'Thêm vị trí', edit: 'Sửa vị trí', create: 'Tạo vị trí' },
  columns: {
    chiNhanh: 'Chi nhánh',
    code: 'Mã vị trí',
    summary: 'Tên vị trí',
    note: 'Ghi chú',
    ngayTao: 'Ngày tạo',
    ngayCapNhat: 'Ngày cập nhật',
    status: 'Trạng thái',
    onOffAction: 'Bật tắt',
  },
  filter: {
    searchPlaceholder: 'Tìm theo mã / tên vị trí...',
    textDetailTitle: 'Bộ lọc chi tiết',
  },
  filters: {
    hintSection: 'Gợi ý',
    hintBody: 'Danh mục vị trí lưu kho dùng cho hàng hóa.',
    statusAll: 'Tất cả',
    chiNhanhAll: 'Tất cả chi nhánh',
    chiNhanhSearch: 'Tìm chi nhánh',
    chiNhanhEmpty: 'Không có chi nhánh',
  },
  status: {
    dangHoatDong: 'Đang hoạt động',
    ngungHoatDong: 'Ngừng hoạt động',
  },
  actions: {
    pause: 'Ngừng hoạt động',
    activate: 'Kích hoạt',
  },
  messages: {
    loadError: 'Không tải được danh sách vị trí.',
    deleteSuccess: 'Đã xóa vị trí.',
    noData: 'Không có vị trí.',
    listSummary: 'Tổng {count} mục',
    saveSuccess: 'Đã lưu vị trí.',
    statusChanged: 'Đã cập nhật trạng thái.',
    createSuccess: 'Tạo vị trí thành công',
    selectedCount: 'Đã chọn {count}',
    deleteSelected: 'Xóa đã chọn ({count})',
    bulkDeleteConfirm: 'Xóa {count} vị trí đã chọn?',
    bulkDeleteSuccess: 'Đã xóa {count} vị trí',
    bulkDeletePartial: 'Đã xóa {ok}/{total}. {failed} mục không xóa được.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    bulkDeleteNoneSelected: 'Chưa chọn vị trí nào để xóa',
  },
  form: {
    tenViTri: 'Tên vị trí',
    tenViTriInline: 'Vị trí',
    maViTri: 'Mã vị trí (tuỳ chọn)',
    ghiChu: 'Ghi chú',
  },
  validation: {
    tenRequired: 'Vui lòng nhập tên vị trí.',
  },
  import: {
    description:
      'File Excel gồm 3 cột: Mã vị trí (tuỳ chọn), Tên vị trí (bắt buộc), Ghi chú (tuỳ chọn). Để trống mã thì hệ thống tự sinh. Có mã trùng sẽ cập nhật.',
    success: 'Đã nhập vị trí từ Excel.',
    failed: 'Nhập vị trí từ Excel thất bại.',
    empty: 'File Excel không có dữ liệu hợp lệ.',
  },
  placeholders: {
    formTitle: 'Vị trí kho',
    formBody: '',
    tenViTri: 'Nhập tên vị trí',
  },
}
